export default [
  {
    'title': '¡0 de 10!',
    'number': '0%',
    'quote': 'Tendrás que replantearte tu fanatismo por la Fórmula E. Demostraste un nulo conocimiento, y ni siquiera de suerte le apuntaste a alguna. 0 conocimiento y 0 suerte.'
  },
  {
    'title': '¡Casi en el subsuelo!',
    'number': '',
    'quote': 'Poco y nada sabes de la fiesta que se tomará la capital este 26 de enero. Te quedan pocos días para recuperar terreno.'
  },
  {
    'title': 'Mal, mal, mal…',
    'number': '',
    'quote': 'Derechamente lo tuyo parece no ser la Fórmula E. Tendrás que entrenar bastante duro para mejorar.'
  },
  {
    'title': 'Al filo del desconocimiento',
    'number': '',
    'quote': 'Piensas que sabes, pero te tengo malas noticias: No dominas siquiera lo básico. Tendrás que hacerte el ánimo de informarte para que disfrutes a concho el Santiago ePrix de este 26 de enero.'
  },
  {
    'title': 'Principiante',
    'number': '',
    'quote': 'Si bien respondiste bien cuatro preguntas, eres de los primeros en escalafón que sumó más malas que buenas. ¿Te parece aceptable? Revisa el especial, lee con atención y responde nuevamente. Estás a poco de pasar al lado bueno de la fuerza.'
  },
  {
    'title': 'Amateur',
    'number': '',
    'quote': 'Ni tan mal ni tan bien. Acertaste la misma cantidad de las que erraste. Probablemente comenzaste a ver las carreras apenas este año. Con un poco más de esfuerzo avanzarás en la trivia. '
  },
  {
    'title': 'Conoces apenas un poco más de aquello que desconoces',
    'number': '',
    'quote': 'Tienes conocimientos básicos, eso no se puede dudar. Pero, ¿Podrías hablar media hora sobre la Fórmula E? Tu resultado deja muchas dudas. '
  },
  {
    'title': 'Podrías hablar con un piloto perfectamente',
    'number': '',
    'quote': 'No está para nada mal. Dominas varios aspectos de la competencia y vibras con las carreras. Si te animas, podrías mejorar.'
  },
  {
    'title': '¡Te luces!',
    'number': '',
    'quote': 'Sabes mucho del presente y del pasado de la Fórmula E. Probablemente el 26 de enero seas uno más de los que estará en el Parque O’Higgins.'
  },
  {
    'title': 'Un fan que siempre está al día',
    'number': '',
    'quote': 'Te encanta la Fórmula E y lees toda la info que aparezca de tus pilotos favoritos. Estuviste muy cerca de acertar a todas.'
  },
  {
    'title': 'Un verdadero sabelotodo de la Fórmula E',
    'number': '',
    'quote': 'Eres de los que se levanta temprano cada sábado para ver la Fórmula E y estás al tanto de todo lo que rodea a la competencia de autos eléctricos más importante del mundo. Felicitaciones.'
  }
]